import React from 'react'
import { connect } from 'react-redux'
import { compose } from 'redux'
import toJS from '../../../hoc/toJS';
import getTranslationTime from '../func/getTranslationTime'

const mapStateToProps = (state, ownProps) => ({
    currentLang: state.getIn(['translation', 'currentLang']),
    timezone: state.getIn(['translation', 'timezone']),
    debug: state.getIn(['translation', 'debug'])
})

const TranslationTime = ({id, timezone, currentLang, timeString, debug, before="", after=""}) => {
    return getTranslationTime(id, timezone, currentLang, timeString, debug, before, after)
}

export default compose(
    connect(mapStateToProps, null),
    toJS(),
)(TranslationTime)